
ADILF.define('streamhub-sdk/content/views/mixins/facebook-content-view-mixin',['require','exports','module'],function (require, exports, module) {'use strict';

/**
 * A mixin that decorates an instance of ContentView 
 * to have a bounded visible set
 */
function asFacebookContentView(contentView, opts) {
    opts = opts || {};
    var elClass = opts.elClass || 'content-facebook';
    contentView.$el.addClass(elClass);

    /**
     * Render the content inside of the LivefyreContentView's element.
     * @returns {LivefyreContentView}
     */
    var oldRender = contentView.render;
    contentView.render = function () {
        oldRender.apply(contentView, arguments);
        contentView.$el.addClass(elClass);
    };
};

module.exports = asFacebookContentView;

});
